import { useRef, useEffect, useState } from "react";
import ClientsFeedback from "./ClientsFeedback";
import "../css/flaticon.min.css";
import "../Main.css";
import { Link } from "react-router-dom";

import Header from "../Home/Header";
import Marquee from "react-fast-marquee";
import Hero1 from "../Home/Hero1";
import Hero2 from "../Home/Hero2";


import {
  Button,
  Card,
  
  CardContent,

  Typography,
  useMediaQuery,
} from "@mui/material";
import { LiaHandshakeSolid } from "react-icons/lia";
import CountUp from "react-countup";
import Customization from "./Customization";
import { GiRead } from "react-icons/gi";


const CoreFeatures = () => {
  const [scrolled, setScrolled] = useState(false);
  
  const [open] = useState(false);
    console.log(scrolled,open);

 

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;

      // Determine the scroll threshold where the header should become fixed
      const scrollThreshold = 100;

      // Update the state based on the scroll position
      setScrolled(scrollTop > scrollThreshold);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Remove scroll event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const valueRef = useRef<HTMLDivElement | null>(null);
  const projectRef = useRef<HTMLDivElement | null>(null);
  const teamRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateValue(valueRef, 0, 2365, 1000);
          animateValue(projectRef, 0, 5234, 1000);
          animateValue(teamRef, 0, 8532, 1000);
        }
      });
    }, options);

    if (valueRef.current) observer.observe(valueRef.current);
    if (projectRef.current) observer.observe(projectRef.current);
    if (teamRef.current) observer.observe(teamRef.current);
  }, []);

  function animateValue(obj: any, start: any, end: any, duration: any) {
    let startTimestamp: any = null;

    const step = (timestamp: any) => {
      if (!startTimestamp) startTimestamp = timestamp;

      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const currentValue = Math.floor(progress * (end - start) + start);
      obj.current.innerText = currentValue.toString() + "+";

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }




  const client = [
    "/assets/c1.webp",
    "/assets/c2.webp",
    "/assets/c3.webp",
    "/assets/c4.webp",
    "/assets/c5.webp",
    "/assets/c6.webp",
    "/assets/c7.webp",
    // "/assets/c8.webp",
  ];

  const images = ["/assets/w1.webp", "/assets/w2.webp", "/assets/w3.webp"];

  const [currentIndex, setCurrentIndex] = useState(0);
  console.log(currentIndex);
  


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); 
    return () => clearInterval(interval);
  }, [images.length]);


  const [triggerCount, setTriggerCount] = useState(false);
  const sectionRef = useRef(null);

//   useEffect(() => {
//   const currentSection = sectionRef.current; 

//   if (!currentSection) return;

//   const observer = new IntersectionObserver(
//     (entries) => {
//       if (entries[0].isIntersecting) {
//         setTriggerCount(true);
//       }
//     },
//     { root: null, threshold: 0.2 }
//   );

//   observer.observe(currentSection);

//   return () => {
//     observer.unobserve(currentSection); // cleanup uses the same snapshot
//   };
// }, []);


useEffect(() => {
  // 1. Copy the ref value to a local variable for stable cleanup
  const currentSection = sectionRef.current;

  if (!currentSection) return;

  const observer = new IntersectionObserver(
    (entries) => {
      // Best practice: use the first entry specifically
      if (entries[0].isIntersecting) {
        setTriggerCount(true);
      }
    },
    { root: null, threshold: 0.2 }
  );

  // 2. Start observing
  observer.observe(currentSection);

  return () => {
    // 3. Use the local variable to ensure the correct node is unobserved
    if (currentSection) {
      observer.unobserve(currentSection);
    }
  };
  // 4. Include setTriggerCount to satisfy the linter
}, [setTriggerCount]); 

  const [animate, setAnimate] = useState(false);

  const cards = [
    { id: 0, color: "/assets/w1.webp" },
    { id: 1, color: "/assets/w2.webp" },
    { id: 2, color: "/assets/w3.webp" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 3000);
    }, 3500);

    return () => clearInterval(interval);
  }, []);
  const isMobile = useMediaQuery("(max-width:708px)");


  return (
    <>
      <nav className="navbar fixed-top navbar-light bg-white">
  <Header />
</nav>

       {!isMobile && <Hero1 />}


      <section
        className="about-area-one pt-70 pb-125 rel z-1"
        style={{ overflow: "hidden", backgroundColor: "#F7F7F7" }}
      >
        {isMobile && <Hero2 /> }
        <div className="container pt-20">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-5">
              <div className="about-image-one bg-squire-shape rmb-85 wow fadeInUp delay-0-2s">
                <img
                  src="/assets/about-imgs.webp"
                  alt="About us"
                  loading="lazy"



                />
              </div>
            </div>
            <div className="col-xl-6 col-lg-7">
              <div className="about-content-one wow fadeInUp delay-0-4s">
                <div className="section-title mb-45">
                  <span className="sub-title mb-15  wow fadeInUp delay-0-4s">
                    \ Who We Are \
                  </span>
                  <h2 className=" wow fadeInUp delay-0-4s">
                    The TechHorse Technology
                  </h2>
                </div>
                <ul className="list-style-one">
                  <li>
                    <div className="content  wow fadeInUp delay-0-4s">
                      <h2 className="mb-4" >Our Mission</h2>
                      <p >
                        At The TechHorse, we don't just build websites—we craft
                        digital experiences that drive real business results.
                        The Tech Horse operates as the Best web development
                        company in Chennai by delivering personalized and
                        result-oriented web solutions which benefit businesses
                        of various scales.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="content wow fadeInUp delay-0-4s ">

                      <h2 >Future Vision</h2>
                      <p className="mb-4">
                        Through our services we power numerous businesses to
                        excel online by building them reliable websites combined
                        with effective digital marketing approaches. Every
                        business can trust The Tech Horse as the solution
                        provider for website development and e-commerce
                        platforms and digital marketing services.
                      </p>
                    </div>
                  </li>
                </ul>
                <div className="instant">
                  <div>
                    <div className="img-iconsbg">
                      <img
                        className="img-fluid"
                        alt="img"
                        loading="lazy"
                        src="/assets/Black.png"
                      />
                    </div>
                  </div>
                  <div className="ms-3  wow fadeInUp delay-0-4s">
                    <p>Get Instant Professional Advice</p>
                    <span>Ready to Help :</span>
                    <a
                      className="ms-2"
                      href="tel:+91 9799184337"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#F6AF03" }}
                    >
                      +91 9799184337
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About Us Area end */}

      {/* Partner Area start */}

      <section className=" pt-130 pb-100 partnerBG">
        <div className="container">
          <div className="oodo  wow fadeInUp delay-0-4s">
            <div className="me-2">
              <p>
                <LiaHandshakeSolid />
                MEET OUR
              </p>
              <h6>TRUSTED</h6>
              <h6>PARTNER</h6>
              <img
                src="/assets/oddo 1.png"
                className="img-fluid"
                loading="lazy"
                alt="oodo"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Partner Area end */}

      {/* Client Area start */}

      <section className=" pt-80 pb-50">
        <div className="container">
          <div className="section-title mb-45 text-center">
            <span className="sub-title mb-15  wow fadeInUp delay-0-4s">
              \ Our Valued Clients \
            </span>
            <h2
              className="m-auto  wow fadeInUp delay-0-4s"
              style={{ width: "60%" }}
            >
              Trusted by Businesses Across Industries Who Believe in Digital
              Excellence
            </h2>
          </div>
        </div>
        <div style={{ backgroundColor: "#EDEDED80" }}>
          <div className="py-3">
            <Marquee>
              {client.map((src:any, index:any) => (
                <div key={index} className="" style={{ padding: "0 10px" }}>
                  <img
                    src={src}
                    className="img-fluid lci"
                    alt={`marquee-img-${index}`}
                    loading="lazy"
                  />
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      </section>

      {/* Client Area end */}

      {/* experience Area start */}
      <section className=" pt-50 pb-50" ref={sectionRef}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-12 col-12 ex-border">
              <div className="experi-para py-3  wow fadeInUp delay-0-4s">
                <p>Experience</p>
                <p>The TechHorse</p>
                <p>Touch</p>
              </div>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12 col-12">
              <div className="ex-number">
                <div className="row">
                  <div className="col-lg-6 col-sm-6 col-md-6 col-6 p-0">
                    <div className="ex1-border ex2-border p-2">
                      <h1>
                        {" "}
                        {triggerCount ? (
                          <CountUp
                            end={12}
                            duration={2}
                            suffix="+"
                            className="klj"
                          />
                        ) : (
                          "0+"
                        )}
                      </h1>
                      <span>Years Experience</span>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-md-6 col-6 p-0">
                    <div className="ex2-border p-2">
                      <h1>
                        {" "}
                        {triggerCount ? (
                          <CountUp
                            end={50}
                            duration={2}
                            suffix="+"
                            className="klj"
                          />
                        ) : (
                          "0+"
                        )}
                      </h1>
                      <span>Clients</span>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-md-6 col-6  p-0">
                    <div className="ex1-border p-2">
                      <h1 className="pt-2">
                        {" "}
                        {triggerCount ? (
                          <CountUp
                            end={50}
                            duration={2}
                            suffix="+"
                            className="klj"
                          />
                        ) : (
                          "0+"
                        )}
                      </h1>
                      <span>Associates</span>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-md-6 col-6  p-0">
                    <div className=" p-2">
                      <h1 className="pt-2">
                        {" "}
                        {triggerCount ? (
                          <CountUp
                            end={100}
                            duration={2}
                            suffix="+"
                            className="klj"
                          />
                        ) : (
                          "0+"
                        )}
                      </h1>
                      <span>Projects</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* experience Area end */}

      {/* we do Area start */}

      <section className=" pt-50 pb-50">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="">
                <div className="card-wrapper">
                  <ul className={`card-list ${animate ? "is-animated" : ""}`}>
                    {cards.map((card) => (
                      <li
                        key={card.id}
                        className="card-list__item"
                        data-card={card.id}
                      >
                        <div className="cardd">
                          <img
                            src={card.color}
                            loading="lazy"
                            alt="img"
                            className="img-fluid"
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12 pad">
              <div>
                <div className="section-title mb-45">
                  <span className="sub-title mb-10  wow fadeInUp delay-0-4s">
                    \ What We Do \
                  </span>
                  <h2 className=" wow fadeInUp delay-0-4s">
                    Why We're the Best Web Development Company in Chennai
                  </h2>
                </div>
                <div className=" wow fadeInUp delay-0-4s">
                  <ul className="custom-list2">
                    <li>
                      We construct websites which express your organization's
                      identity and business targets.
                    </li>
                    <li>
                      The strategy focuses on developing smooth user pathways
                      that enhance user interaction and drive better conversion
                      results.
                    </li>
                    <li>
                      We construct websites which express your organization's
                      identity and business targets.
                    </li>
                    <li>
                      The codes we produce for websites incorporate SEO
                      guidelines together with speedy performance for search
                      rankings.
                    </li>
                    <li>
                      Devices differ but your site maintains flawless
                      presentation on mobile phones and desktops.
                    </li>
                    <li>
                      As a company we construct scalable websites that operate
                      securely while adapting to your business requirements.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* we do Area end */}

      {/* Plan Area start */}

      <section
        className=" pt-100 pb-100"
        style={{ backgroundColor: "#F7F9FD" }}
      >
        <div className="container">
          <div className="section-title mb-45 text-center">
            <span className="sub-title mb-15  wow fadeInUp delay-0-4s">
              \ Planning \
            </span>
            <h2
              className="m-auto  wow fadeInUp delay-0-4s"
              style={{ width: "60%" }}
            >
              Our Process
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12 p-2">
              <div style={{ backgroundColor: "#fff" }} className="plan-maind">
                <div className="box-plan1">
                  <img
                    src="/assets/pl1.webp"
                    className="img-fluid dancing-icon"
                    alt="img"
                    loading="lazy"
                  />
                  <h6>01</h6>
                </div>
                <p className="plan-title  wow fadeInUp delay-0-4s">Research</p>
                <div className="d-flex py-2">
                  <div className="yellow1"></div>
                  <div className="yellow2"></div>
                </div>
                <p className="plan-para  wow fadeInUp delay-0-4s">
                  The trends of the market, audience’s behavior, and strategy of
                  the competitors to create a solid base for the project
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12 p-2">
              <div style={{ backgroundColor: "#fff" }} className="plan-maind">
                <div className="box-plan1">
                  <img
                    src="/assets/pl2.webp"
                    className="img-fluid dancing-icon"
                    alt="img"
                    loading="lazy"
                  />
                  <h6>02</h6>
                </div>
                <p className="plan-title  wow fadeInUp delay-0-4s">Design</p>
                <div className="d-flex py-2">
                  <div className="yellow1"></div>
                  <div className="yellow2"></div>
                </div>
                <p className="plan-para  wow fadeInUp delay-0-4s">
                  Each design element is designed in a way that will represent
                  your brand and improve the interaction between the users.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12 p-2">
              <div style={{ backgroundColor: "#fff" }} className="plan-maind">
                <div className="box-plan1">
                  <img
                    src="/assets/pl3.webp"
                    className="img-fluid dancing-icon"
                    alt="img"
                    loading="lazy"
                  />
                  <h6>03</h6>
                </div>
                <p className="plan-title  wow fadeInUp delay-0-4s">Develope</p>
                <div className="d-flex py-2">
                  <div className="yellow1"></div>
                  <div className="yellow2"></div>
                </div>
                <p className="plan-para  wow fadeInUp delay-0-4s">
                  We do this using the latest technologies in order to achieve
                  speed, security and scalability.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12 p-2">
              <div style={{ backgroundColor: "#fff" }} className="plan-maind">
                <div className="box-plan1">
                  <img
                    src="/assets/pl4.webp"
                    className="img-fluid dancing-icon"
                    alt="img"
                    loading="lazy"
                  />
                  <h6>04</h6>
                </div>
                <p className="plan-title  wow fadeInUp delay-0-4s">Test</p>
                <div className="d-flex py-2">
                  <div className="yellow1"></div>
                  <div className="yellow2"></div>
                </div>
                <p className="plan-para  wow fadeInUp delay-0-4s">
                  At the level of usability to cross-device compatibility, we do
                  not leave any bugs behind.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Plan Area end */}

      <section
        className=" pt-100 pb-100"
        style={{ backgroundColor: "#011C2B" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-6 col-sm-12 col-12 sticky-div">
              <div>
                <div className="section-title mb-45">
                  <span className="sub-title mt-3 mb-2  wow fadeInUp delay-0-4s">
                    \ Service \
                  </span>
                  <h2
                    className=" wow fadeInUp delay-0-4s"
                    style={{ color: "#fff" }}
                  >
                    Web Development Services We Offer
                  </h2>
                </div>
                <p className="para  wow fadeInUp delay-0-4s">
                  Under our position as the Best web development company in
                  Chennai we provide comprehensive web development services that
                  fulfill every need of our clients.
                </p>
              </div>
            </div>
            <div className="col-lg-7 col-sm-12 col-12 col-md-6 right-autos">
              <div className="row">
                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mb-4">
                  <div className="plan-maind">
                    <div
                      className="box-plan1 d-flex justify-content-center align-items-center"
                      style={{
                        background: "#fff",
                        width: "80px",
                        height: "80px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src="/assets/sn1.webp"
                        className="img-fluid dancing-icon"
                        alt="img"
                        loading="lazy"
                      />
                    </div>
                    <p
                      className="plan-title  wow fadeInUp delay-0-4s"
                      style={{ color: "#fff" }}
                    >
                      Custom Website Development
                    </p>
                    <div className="d-flex py-3">
                      <div className="yellow1"></div>
                      <div className="yellow2"></div>
                    </div>
                    <p
                      className="plan-para  wow fadeInUp delay-0-4s"
                      style={{ color: "#D9D9D9" }}
                    >
                      Our company builds customized websites which implement
                      your brand identity along with your business requirements.
                      Fast, secure, and fully responsive for all devices.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-4"></div>

                <div className="col-lg-4 col-md-4 col-sm-12 mb-4"></div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mb-4">
                  <div className="plan-maind">
                    <div
                      className="box-plan1 d-flex justify-content-center align-items-center"
                      style={{
                        background: "#fff",
                        width: "80px",
                        height: "80px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src="/assets/sn2.webp"
                        className="img-fluid dancing-icon"
                        alt="img"
                        loading="lazy"
                      />
                    </div>
                    <p
                      className="plan-title  wow fadeInUp delay-0-4s"
                      style={{ color: "#fff" }}
                    >
                      E-commerce Website Design
                    </p>
                    <div className="d-flex py-3">
                      <div className="yellow1"></div>
                      <div className="yellow2"></div>
                    </div>
                    <p
                      className="plan-para  wow fadeInUp delay-0-4s"
                      style={{ color: "#D9D9D9" }}
                    >
                      Your new online store should feature a user-friendly
                      interface, safe payment methods, and an easy shopping
                      process to maximize your prospects for increased revenue.
                    </p>
                  </div>
                </div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mb-4">
                  <div className="plan-maind">
                    <div
                      className="box-plan1 d-flex justify-content-center align-items-center"
                      style={{
                        background: "#fff",
                        width: "80px",
                        height: "80px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src="/assets/sn4.webp"
                        className="img-fluid dancing-icon"
                        alt="img"
                        loading="lazy"
                      />
                    </div>
                    <p
                      className="plan-title  wow fadeInUp delay-0-4s"
                      style={{ color: "#fff" }}
                    >
                      Website Redesign Services
                    </p>
                    <div className="d-flex py-3">
                      <div className="yellow1"></div>
                      <div className="yellow2"></div>
                    </div>
                    <p
                      className="plan-para  wow fadeInUp delay-0-4s"
                      style={{ color: "#D9D9D9" }}
                    >
                      Upgrade your site by implementing a contemporary design
                      and these improvements: superior speed and SEO performance
                      and enhanced user interaction.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-4"></div>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-4"></div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mb-4">
                  <div className="plan-maind">
                    <div
                      className="box-plan1 d-flex justify-content-center align-items-center"
                      style={{
                        background: "#fff",
                        width: "80px",
                        height: "80px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src="/assets/sn3.webp"
                        className="img-fluid dancing-icon"
                        alt="img"
                        loading="lazy"
                      />
                    </div>
                    <p
                      className="plan-title  wow fadeInUp delay-0-4s"
                      style={{ color: "#fff" }}
                    >
                      App Development
                    </p>
                    <div className="d-flex py-3">
                      <div className="yellow1"></div>
                      <div className="yellow2"></div>
                    </div>
                    <p
                      className="plan-para  wow fadeInUp delay-0-4s"
                      style={{ color: "#D9D9D9" }}
                    >
                      We construct high-functioning app solutions between ideas
                      and launch by developing mobile and web applications with
                      intuitive design coupled with functional experiences.
                    </p>
                  </div>
                </div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mb-4">
                  <div className="plan-maind">
                    <div
                      className="box-plan1 d-flex justify-content-center align-items-center"
                      style={{
                        background: "#fff",
                        width: "80px",
                        height: "80px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src="/assets/sn6.webp"
                        className="img-fluid dancing-icon"
                        alt="img"
                        loading="lazy"
                      />
                    </div>
                    <p
                      className="plan-title  wow fadeInUp delay-0-4s"
                      style={{ color: "#fff" }}
                    >
                      Website Maintenance & Support{" "}
                    </p>
                    <div className="d-flex py-3">
                      <div className="yellow1"></div>
                      <div className="yellow2"></div>
                    </div>
                    <p
                      className="plan-para  wow fadeInUp delay-0-4s"
                      style={{ color: "#D9D9D9" }}
                    >
                      Your website runs without interruptions when you use
                      regular updates and perform backups and security checks
                      and avail technical support alongside scheduled
                      maintenance.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-4"></div>

                <div className="col-lg-4 col-md-4 col-sm-12 mb-4"></div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mb-4">
                  <div className="plan-maind">
                    <div
                      className="box-plan1 d-flex justify-content-center align-items-center"
                      style={{
                        background: "#fff",
                        width: "80px",
                        height: "80px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src="/assets/sn5.webp"
                        className="img-fluid dancing-icon"
                        alt="img"
                        loading="lazy"
                      />
                    </div>
                    <p
                      className="plan-title  wow fadeInUp delay-0-4s"
                      style={{ color: "#fff" }}
                    >
                      Digital Marketing
                    </p>
                    <div className="d-flex py-3">
                      <div className="yellow1"></div>
                      <div className="yellow2"></div>
                    </div>
                    <p
                      className="plan-para  wow fadeInUp delay-0-4s"
                      style={{ color: "#D9D9D9" }}
                    >
                      Your online business expansion can succeed through SEO in
                      addition to Google Ads along with social media marketing
                      and content creation that produces actual business
                      outcomes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Customization />

      {/* Design Featured Start */}
      <section className="design-feature-area overflow-hidden pt-130 pb-100 text-white bgc-black-with-lighting2 rel z-1">
        <div className="container">
          <div className="section-title text-center mb-60 wow fadeInUp delay-0-2s">
            <span className="sub-title mb-10">\ Core Design Featured \</span>
            <h2 style={{ color: "#fff" }}>What We Provide for Businesses</h2>
            <p className="fetaj">
              At The TechHorse, we provide you with innovative and scalable
              digital deployments to help you grow and drive efficiency in
              business. From websites to mobile apps and enterprise software, we
              turn your ideas into powerful digital experiences.
            </p>
          </div>
          <div className="row no-gap align-items-center">
            <div className="col-lg-3">
              <div className="feature-left">
                <div className="row">
                  <div className="col-lg-12 col-sm-6">
                    <div className="service-item style-three wow fadeInRight delay-0-2s">
                      <div className="d-flex justify-content-start align-items-center">
                        <div className="ico2n">
                          <img
                            style={{ width: "40px" }}
                            src="/assets/sn1.webp"
                            alt="icon"
                            className="img-fluid dancing-icon"
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <span>Web Design & Development</span>
                        </div>
                      </div>
                      <div className="content">
                        <p className="para22">
                          We design responsive, easy to navigate websites that
                          will represent your brand and generate online success.
                          Our designs are optimized for performance, speed, and
                          SEO to maximize your digital impact.
                        </p>

                        <Link to="/web-development" className="more-btn">
                          
                            <i className="fal fa-long-arrow-right" />
                        
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-6">
                    <div className="service-item style-three wow fadeInRight delay-0-3s">
                      <div className="d-flex justify-content-start align-items-center">
                        <div className="ico2n">
                          <img
                            style={{ width: "40px" }}
                            src="/assets/sn3.webp"
                            alt="icon"
                            className="img-fluid dancing-icon"
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <span>Mobile App Development</span>
                        </div>
                      </div>
                      <div className="content">
                        <p className="para22">
                          Our team develops intuitive mobile applications for
                          iOS and Android that connect with your audience and
                          increase your reach. From wireframes to launch, we
                          ensure a seamless user experience and flawless
                          functionality.
                        </p>
                        <Link to="/mobile-app-development" className="more-btn">
                          
                            <i className="fal fa-long-arrow-right" />
                          
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="feature-middle rmt-30">
                <div className="image wow fadeInUp delay-0-2s">
                  <img
                    className="round"
                    src="/assets/cj.webp"
                    alt="Feature Middle"
                    loading="lazy"
                  />
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="service-item style-three wow fadeInUp delay-0-3s">
                      <div className="d-flex justify-content-start align-items-center">
                        <div className="ico2n">
                          <img
                            style={{ width: "40px" }}
                            src="/assets/sn2.webp"
                            alt="icon"
                            className="img-fluid dancing-icon"
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <span>Software Development</span>
                        </div>
                      </div>
                      <div className="content">
                        <p className="para22">
                          We create custom software solutions which streamline
                          operations and increase productivity. Our scalable
                          applications are built to grow with your company and
                          adapt to future demands.
                        </p>
                        <Link to="/software-development" className="more-btn">
                            <i className="fal fa-long-arrow-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="service-item style-three mt-30 wow fadeInUp delay-0-4s">
                      <div className="d-flex justify-content-start align-items-center">
                        <div className="ico2n">
                          <img
                            style={{ width: "40px" }}
                            src="/assets/sn4.webp"
                            alt="icon"
                            className="img-fluid dancing-icon"
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <span>DevOps</span>
                        </div>
                      </div>
                      <div className="content">
                        <p className="para22">
                          Streamline your development cycle using our strong
                          DevOps practices and secure easy deployment and
                          scalability. We integrate CI/CD pipelines, monitoring,
                          and cloud environments for faster release cycles.
                        </p>
                        <Link to="/dev-ops" className="more-btn">
                        
                            <i className="fal fa-long-arrow-right" />
                         
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="feature-right">
                <div className="row">
                  <div className="col-lg-12 col-sm-6">
                    <div className="service-item style-three mt-100 wow fadeInLeft delay-0-2s">
                      <div className="d-flex justify-content-start align-items-center">
                        <div className="ico2n">
                          <img
                            style={{ width: "40px" }}
                            src="/assets/sn5.webp"
                            alt="icon"
                            className="img-fluid dancing-icon"
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <span>Digital Marketing</span>
                        </div>
                      </div>
                      <div className="content">
                        <p className="para22">
                          From SEO to social media, we make your business brand
                          stronger online and open qualified leads. Our
                          data-driven strategies ensure measurable results and
                          continuous optimization.
                        </p>
                        <Link to="/digital-marketing" className="more-btn">
                          
                            <i className="fal fa-long-arrow-right" />
                          
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-6">
                    <div className="service-item style-three wow fadeInLeft delay-0-3s">
                      <div className="d-flex justify-content-start align-items-center">
                        <div className="ico2n">
                          <img
                            style={{ width: "40px" }}
                            src="/assets/sn6.webp"
                            alt="icon"
                            className="img-fluid dancing-icon"
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <span>Cloud Computing</span>
                        </div>
                      </div>
                      <div className="content">
                        <p className="para22">
                          Leverage our cloud services to increase flexibility,
                          reduce costs, and ensure data security at scale. We
                          support cloud migration, infrastructure management,
                          and 24/7 monitoring to ensure uptime and performance.
                        </p>
                        <Link to="/cloud-computing" className="more-btn">
                        
                            <i className="fal fa-long-arrow-right" />
                         
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="design-feature-shapes">
          <img
            className="shape dots"
            src="/images/shapes/slider-dots.png"
            alt="Shape"
            loading="lazy"
          />
          <img
            className="shape wave-line"
            src="/images/shapes/feature-wave-line.png"
            alt="Shape"
            loading="lazy"
          />
        </div>
      </section>
      {/* Design Featured End */}

      <ClientsFeedback />

      <section className=" pt-100 pb-40" style={{ backgroundColor: "#fff" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12 d-flex justify-content-center align-items-center ol">
              <div style={{ width: "100%", height: "100%" }} className="op">
                <div
                  className="position-relative"
                  style={{ width: "70%", height: "100%" }}
                >
                  <div className="yellow-div"></div>
                  <div className="yellow-img">
                    <img
                      className="img-fluid"
                      alt="img"
                      loading="lazy"
                      src="/assets/ko2.webp"
                    />
                  </div>
                  <span className="yelow-spana  wow fadeInUp delay-0-4s">
                    AI Data Analytics
                  </span>
                  <div className="yellow-sdf">
                    <img
                      className="img-fluid"
                      alt="img"
                      loading="lazy"
                      src="/assets/sdf.png"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12 d-flex justify-content-center align-items-center ol">
              <div style={{ width: "100%", height: "100%" }} className="op">
                <div
                  className="position-relative"
                  style={{ width: "70%", height: "100%" }}
                >
                  <div className="yellow-div2"></div>
                  <div className="yellow-img2">
                    <img
                      className="img-fluid"
                      alt="img"
                      loading="lazy"
                      src="/assets/ko1.webp"
                    />
                  </div>
                  <span
                    className="yelow-spana2  wow fadeInUp delay-0-4s"
                    style={{ color: "#fff" }}
                  >
                    Business Analytics
                  </span>
                  <div className="yellow-sdf2">
                    <img
                      className="img-fluid"
                      alt="img"
                      loading="lazy"
                      src="/assets/jis.png"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12 fgd">
              <div>
                <div className="section-title mb-45">
                  <span className="sub-title mb-0  wow fadeInUp delay-0-4s">
                    \ AI Based Service \
                  </span>
                  <h2
                    className=" wow fadeInUp delay-0-4s"
                    style={{ color: "#0E1F51" }}
                  >
                    Data and Business Analytics
                  </h2>
                  <p className="mb-0 para22  wow fadeInUp delay-0-4s">
                    Turn Data into Actionable Insights with The TechHorse.
                  </p>
                  <p className="para22  wow fadeInUp delay-0-4s">
                    In today’s digital world, data is the new fuel for growth.
                    We, at The TechHorse, aid businesses to realise their data’s
                    full potential through systems that use intelligent
                    analytics to inspire decisions, optimise the way one works
                    and ignite innovation.
                  </p>
                  <h6 className="asd  wow fadeInUp delay-0-4s">
                    Our Data & Business Analytics Services Offers:
                  </h6>
                  <div>
                    <ul className="custom-list22  wow fadeInUp delay-0-4s">
                      <li>Data Visualization & Reporting</li>
                      <li>Predictive Analytics</li>
                      <li>Business Intelligence (BI)</li>
                      <li>Data Warehousing & Integration</li>
                      <li>Big Data Solutions</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG */}
      <section className=" pt-30 pb-100" style={{ backgroundColor: "#fff" }}>
        <div className="container">
          <div className="section-title mb-45 text-center">
            <span className="sub-title mb-10  wow fadeInUp delay-0-4s">
              \ Blogs \
            </span>
            <h2 className=" wow fadeInUp delay-0-4s">
              What’s new at The TechHorse
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-4 col-12 col-sm-12 p-2">
              <div>
                <Card
                  sx={{ minWidth: 275 }}
                  style={{ background: "#F6F6F6", borderRadius: "16px" }}
                >
                  <CardContent>
                    <div style={{ height: "200px", overflow: "hidden" }}>
                      <img

                        className="img-fluid"
                        src="/assets/tthb-de.jpg"
                        alt="img"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    </div>{" "}
                    <Typography variant="h5" component="div" className="sff">
                      Digital Marketing Strategies for Dentists - Top Guide
                    </Typography>
                    <div>
                      <Link to="/blogs/digital-marketing-stratgies-for-detists">
                        <Button size="small" className="read">
                          <GiRead className="me-1" /> Read Now
                        </Button>
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 col-sm-12 p-2">
              <div>
                <Card
                  sx={{ minWidth: 275 }}
                  style={{ background: "#F6F6F6", borderRadius: "16px" }}
                >
                  <CardContent>
                    <div style={{ height: "200px", overflow: "hidden" }}>
                      <img
                        className="img-fluid"
                        src="/assets/tthb-dk.jpeg"
                        alt="img"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                    <Typography variant="h5" component="div" className="sff">
                      Keywords in Digital Marketing – Best Strategies for SEO
                      Success
                    </Typography>
                    <div>
                      <Link to="/blogs/keywords-in-digital-marketing">
                        <Button size="small" className="read">
                          <GiRead className="me-1" /> Read Now
                        </Button>
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 col-sm-12 p-2">
              <div>
                <Card
                  sx={{ minWidth: 275 }}
                  style={{ background: "#F6F6F6", borderRadius: "16px" }}
                >
                  <CardContent>
                    <div style={{ height: "200px", overflow: "hidden" }}>
                      <img
                        className="img-fluid"
                        src="/assets/Web dev.jpg"
                        alt="img"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                    <Typography variant="h5" component="div" className="sff">
                      The Tech Horse: Elevating Website Development in Chennai{" "}
                    </Typography>
                    <div>
                      <Link to="/blogs/the-tech-horse-elevating-website-development-in-chennai">
                        <Button size="small" className="read">
                          <GiRead className="me-1" /> Read Now
                        </Button>
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
          <div className="text-center">
            <Link to="/blogs">
              <Button className="mod">See More</Button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoreFeatures;
